import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/enviroments';


export interface SignPosition {
  page: number;
  x: number;
  y: number;
}

export interface UserSignRequest {
  signerRut: string;
  signerEmail: string;
  signTypeName: string;
  userSignPositions: SignPosition[];
}

export interface RequestSignsPayload {
  companyDocumentId: number;
  userSignRequests: UserSignRequest[];
  signatureType: number;
}

@Injectable({
  providedIn: 'root'
})
export class CompanyDocumentService {
  private readonly baseUrl = `${environment.apiUrl}/CompanyDocument`;

  constructor(private http: HttpClient) { }

  requestSigns(payload: RequestSignsPayload): Observable<any> {
    return this.http.post(`${this.baseUrl}/RequestSigns`, payload);
  }

  requestSignatureLink(rut: string): Observable<any> {
    return this.http.get(`${this.baseUrl.replace('CompanyDocument', 'Company')}/SignerInfoKey/${rut.replaceAll('.', '').split('-')[0]}`);
  }
} 